const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/intake/demands/views/view/$viewId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import i18n from '@/common/translations/i18n';
import { DEMAND_TAB_IDS } from '@/features/intake/components/demands/demand-details/useDemandDetailTabs';
export const demandViewSearchSchema = z.object({
  demandId: z.coerce.number().optional(),
  commentId: z.coerce.number().optional(),
  filter: z.enum(['active', 'archived']).optional(),
  // `catch` so a stale or hand-edited tab id falls back to the default instead of failing the
  // whole route.
  demandTab: z.enum(DEMAND_TAB_IDS as [string, ...string[]]).optional().catch(undefined)
});
export const Route = createFileRoute('/(app)/org/$org/intake/demands/views/view/$viewId/')({
  validateSearch: search => demandViewSearchSchema.parse(search),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    topNav: {
      title: i18n.t($ => $.demand.general.demands.demandView)
    }
  }
});